import { useContext } from 'react'
import RootStore from 'stores/RootStore'
import RootStoreContext from 'stores/RootStoreContext'

type StoreSelector<T> = (store: RootStore) => T

export function useStore(): RootStore
export function useStore<T>(selector: StoreSelector<T>): T
export function useStore<T>(selector?: StoreSelector<T>): RootStore | T {
  const { rootStore } = useContext(RootStoreContext)

  if (!rootStore) {
    throw new Error('rootStore is not initialized')
  }

  return selector ? selector(rootStore) : rootStore
}
